(() => {
 const contact = document.getElementById('whatsapp-button');
 if (!contact) return;
 const mobile = matchMedia('(max-width:767px)');
 const watched = new Set();
 const occupied = new Set();
 const update = () => { contact.hidden = mobile.matches && occupied.size > 0; };
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => entry.isIntersecting ? occupied.add(entry.target) : occupied.delete(entry.target));
  update();
 }, { threshold:0.05 });
 const watch = () => document.querySelectorAll('.gh-scene,.zenith-configurator,.guilds-gallery-upload').forEach(el => {if (!watched.has(el)) {watched.add(el);observer.observe(el);}});
 mobile.addEventListener('change',update);
 watch();
 document.addEventListener('variant:change',watch);
 document.addEventListener('guilds:artwork-preview',watch);
})();
